import React, { useEffect, useState } from "react";
import { AmplitudeLog } from "../../lib/amplitude";
import { ReactComponent as LoadingSpiner } from "../../assets/loading-spinner.svg";
import { ReactComponent as Success } from "../../assets/success.svg";
import { ReactComponent as LogoFull } from "../../assets/logo_full.svg";
import { ReactComponent as GooglePlay } from "../../assets/googleplay.svg";
import { ReactComponent as AppStore } from "../../assets/appstore.svg";
import { AnimatePresence, motion } from "framer-motion";
const Finish: React.FC = () => {
  const [text_position, set_text_position] = useState(0);

  const text_model = [
    "Salvando informações",
    "Verificando pagamentos",
    "Informações salvas!",
    "final",
  ];

  const abrirEmNovaGuia = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      set_text_position((prev) => {
        if (text_model[prev] === "final") {
          clearInterval(interval);
          return prev;
        }
        return prev + 1;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-[100%]  ">
      <>
        {text_model[text_position] === "final" ? (
          <>
            <LogoFull className="w-[10rem] h-[2.1rem]" />
            <p className="mt-[1.8rem] text-center">
              Clique em uma das opções abaixo para baixar o nosso aplicativo
              Kinology
            </p>
            <div className="flex flex-row gap-5 mt-[1.8rem] ">
              <AppStore onClick={() => {
                abrirEmNovaGuia("https://apps.apple.com/br/app/kinology/id1275941432");
                AmplitudeLog("Checkout_Download_App_Clique", { loja_destino: "app_store" });
              }} className="w-[7.2rem] h-[7.2rem] cursor-pointer" />
              <GooglePlay onClick={() => {
                abrirEmNovaGuia("https://play.google.com/store/apps/details?id=com.esportese.elastic&hl=pt_BR");
                AmplitudeLog("Checkout_Download_App_Clique", { loja_destino: "play_store" });
              }} className="w-[7.2rem] h-[7.2rem] cursor-pointer" />
            </div>
          </>
        ) : (
          <>
            {text_model[text_position] === "Informações salvas!" ? (
              <Success className="w-[6.5rem] h-[6.5rem]" />
            ) : (
              <LoadingSpiner className="w-[6.5rem] h-[6.5rem]" />
            )}

            <AnimatePresence mode="wait">
              <motion.span
                key={text_model[text_position]}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                <div className="flex flex-col items-center justify-center h-[100%]  ">
                  <p className="text-green-medium mt-[1.25rem] text-[1.1rem] font-[700]">
                    {text_model[text_position]}
                  </p>
                </div>
              </motion.span>
            </AnimatePresence>
          </>
        )}
      </>
    </div>
  );
};

export default Finish;
